import {
  ApiClient,
  ApiClientStrategyFeeCriteria,
  ApiStrategyTemplate
} from '../../../../../api/_legacy/generated-api'
import { Fee } from '../../../types'
import { formatFees } from '../../../util'
import { StrategyId } from './strategy-slice'

type TemplatesByName = {
  delta1?: ApiStrategyTemplate
  leverageConstantProportion?: ApiStrategyTemplate
  leverageVolatilityControl?: ApiStrategyTemplate
  protectionCppi?: ApiStrategyTemplate
  protectionTipp?: ApiStrategyTemplate
  riskManaged?: ApiStrategyTemplate
}

type FeesByTemplateName = {
  delta1?: ApiClientStrategyFeeCriteria[]
  leverageConstantProportion?: ApiClientStrategyFeeCriteria[]
  leverageVolatilityControl?: ApiClientStrategyFeeCriteria[]
  protectionCppi?: ApiClientStrategyFeeCriteria[]
  protectionTipp?: ApiClientStrategyFeeCriteria[]
  riskManaged?: ApiClientStrategyFeeCriteria[]
}

export function getTemplatesByName(strategyTemplates: ApiStrategyTemplate[]): TemplatesByName {
  const delta1 = strategyTemplates.find(x => x.strategyTemplateId === StrategyId.DELTA_1)

  const riskManaged = strategyTemplates.find(x => x.strategyTemplateId === StrategyId.RISK_MANAGED)

  const leverageConstantProportion = strategyTemplates.find(
    x => x.strategyTemplateId === StrategyId.LEVERAGE_CONSTANT_PROPORTION
  )

  const leverageVolatilityControl = strategyTemplates.find(
    x => x.strategyTemplateId === StrategyId.LEVERAGE_VOL_CONTROL
  )

  const protectionTipp = strategyTemplates.find(
    x => x.strategyTemplateId === StrategyId.PROTECTION_CONTINUOUS
  )

  const protectionCppi = strategyTemplates.find(
    x => x.strategyTemplateId === StrategyId.PROTECTION_TERM
  )

  return {
    delta1,
    riskManaged,
    leverageConstantProportion,
    leverageVolatilityControl,
    protectionTipp,
    protectionCppi
  }
}

export function getFeesByTemplateName(
  client: ApiClient,
  templates: TemplatesByName
): FeesByTemplateName {
  const delta1 = client.defaultFees?.defaultStrategyFees?.filter(
    x => x.strategyTemplateId === templates.delta1?.strategyTemplateId
  )

  const riskManaged = client.defaultFees?.defaultStrategyFees?.filter(
    x => x.strategyTemplateId === templates.riskManaged?.strategyTemplateId
  )

  const leverageConstantProportion = client.defaultFees?.defaultStrategyFees?.filter(
    x => x.strategyTemplateId === templates.leverageConstantProportion?.strategyTemplateId
  )

  const leverageVolatilityControl = client.defaultFees?.defaultStrategyFees?.filter(
    x => x.strategyTemplateId === templates.leverageVolatilityControl?.strategyTemplateId
  )

  const protectionTipp = client.defaultFees?.defaultStrategyFees?.filter(
    x => x.strategyTemplateId === templates.protectionTipp?.strategyTemplateId
  )

  const protectionCppi = client.defaultFees?.defaultStrategyFees?.filter(
    x => x.strategyTemplateId === templates.protectionCppi?.strategyTemplateId
  )

  return {
    delta1,
    riskManaged,
    leverageConstantProportion,
    leverageVolatilityControl,
    protectionTipp,
    protectionCppi
  }
}

export function getFeesByCriteria(
  feeCriteria: ApiClientStrategyFeeCriteria[],
  hasBankGuarantee: boolean,
  leverageRatio: number,
  isRiskManaged: boolean
): Fee[] {
  const isLeveraged = leverageRatio !== 1
  const searchResult = feeCriteria.find(
    x => x.hasBankGuarantee === hasBankGuarantee && x.isLeveraged === isLeveraged
  )
  if (!isRiskManaged) {
    const fees = searchResult
      ? formatFees(searchResult.fees.filter(fee => fee.feeType !== 'RiskControlledPremiumFee'))
      : []
    return fees
  }
  const fees = searchResult ? formatFees(searchResult.fees) : []
  return fees
}
